import { render, staticRenderFns } from "./forgotton.vue?vue&type=template&id=63bd0d78"
import script from "./forgotton.vue?vue&type=script&lang=js"
export * from "./forgotton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports